import React, { useEffect, useRef, useState } from 'react';
import TextareaAutosize from 'react-autosize-textarea/lib';

import style from './RemoteOralExam.scss';
import RemoteOralExamConstants from '../../constants/RemoteOralExamConstants';
import sessionStorageService from '../../services/SessionStorageService';

const NotesInput = () => {
    const AUTO_SAVE_TIMEOUT = 1000; // ms
    const [note, setNote] = useState('');
    const [storeNoteId, setStoreNoteId] = useState(null);
    const noteRef = useRef();

    useEffect(() => {
        const initialNote = sessionStorageService.getItem(RemoteOralExamConstants.sessionStorageKeys.NOTE) || '';
        setNote(initialNote);
        noteRef.current.focus();
    }, []);

    useEffect(() => {
        if (storeNoteId) {
            clearTimeout(storeNoteId);
        }

        const timeoutId = setTimeout(storeNote, AUTO_SAVE_TIMEOUT);
        setStoreNoteId(timeoutId);
    }, [note]);

    const setNoteValue = (event) => {
        setNote(event.target.value);
    };

    const storeNote = () => {
        sessionStorageService.setItem(RemoteOralExamConstants.sessionStorageKeys.NOTE, note);
    };

    return (<TextareaAutosize
        ref={noteRef}
        className={style.notes}
        rows={4}
        value={note}
        onChange={setNoteValue}
        onBlur={storeNote}
    />);
};

export default NotesInput;
